/* eslint-disable */

import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { voterAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type ClaimAllLpRewardProps = {
  account: Address
  chainId: number
  config: Config
  voterAddress: Address
  gauges: Array<any>
  gtokens: Array<any>
  bribes: Array<any>
  btokens: Array<any>
  tokenId: number
}

export const claimAllLpReward = async ({
  account,
  chainId,
  config,
  voterAddress,
  gauges,
  gtokens,
  bribes,
  btokens,
  tokenId,
}: ClaimAllLpRewardProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: voterAbi as Abi,
        account,
        address: voterAddress,
        args: [gauges, gtokens, bribes, btokens, tokenId],
        chainId,
        functionName: "claimEverything",
      },
    })
    return result
  } catch (error: any) {
    console.error("claimAllLpReward", error)
    return { success: false, error: error.message, code: error.code }
  }
}
